export const currencyPattern = /^\d+(\.\d{1,2})?$/;
export const numberFormatPattern = /^-?\d+(\.\d+)?$/;
export const websitePattern =
  /^(https?:\/\/)?([\da-z\.-]+)\.([a-z\.]{2,6})(\/([\da-z\.-]+))*\/?(([\w\.-]+)\.([\da-z]{2,6}))?((\#[\w\.-]+)|(\?([\da-z]+(=[\da-z]+)?)(&([\da-z]+(=[\da-z]+)?))*))?/;
export const zipCodePattern = /^\d{5}(-\d{4})?$/;
// Validation as per https://thedailywtf.com/articles/Validating_Email_Addresses
export const emailPattern =
  /^[-!#$%&'*+/0-9=?A-Z^_a-z{": "}~](\.?[-!#$%&'*+/0-9=?A-Z^_a-z{": "}~])*@[a-zA-Z](-?[a-zA-Z0-9])*(\.[a-zA-Z](-?[a-zA-Z0-9])*)+$/;

export const validationNameRegex = /^(?![ -])[A-Za-z\s-]+$/;
export const validationCompanyNameRegex =
  /^[.@&]?[a-zA-Z0-9 ]+[ !.@&()-]?[ a-zA-Z0-9!()-]+/;
